import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, createBlock as _createBlock, withModifiers as _withModifiers, vShow as _vShow, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d9da0e52"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "opModal" }
const _hoisted_2 = { class: "modalHeader flex-row justify-content-between align-items-center" }
const _hoisted_3 = { class: "modalBody" }
const _hoisted_4 = { class: "d-flex justify-content-around" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(")")
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_7 = { class: "" }
const _hoisted_8 = { class: "form-group" }
const _hoisted_9 = { class: "form-group" }
const _hoisted_10 = { class: "mr-2" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "form-group" }
const _hoisted_13 = { class: "form-group text-center" }
const _hoisted_14 = ["src"]
const _hoisted_15 = ["value"]
const _hoisted_16 = { class: "" }
const _hoisted_17 = { class: "d-flex justify-content-between" }
const _hoisted_18 = {
  key: 0,
  class: "text-right"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_20 = { class: "row" }
const _hoisted_21 = { class: "col-sm-6" }
const _hoisted_22 = { class: "form-group" }
const _hoisted_23 = { value: "" }
const _hoisted_24 = { class: "col-sm-6" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_26 = {
  filter: "name",
  sort: "name"
}
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_28 = { key: 0 }
const _hoisted_29 = { colspan: "99" }
const _hoisted_30 = ["value"]
const _hoisted_31 = { class: "modalFooter text-right" }
const _hoisted_32 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_file_dropper = _resolveComponent("file-dropper")!
  const _component_op_table = _resolveComponent("op-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h4", null, [
        _createVNode(_component_localized_text, {
          localizedKey: "Gestisci documenti dashboard",
          text: "Gestisci documenti dashboard"
        })
      ]),
      (_ctx.docIdentifier)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            type: "button",
            class: "btn btn-sm btn-danger",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.remove && _ctx.remove(...args)))
          }, [
            _createVNode(_component_localized_text, {
              localizedKey: "Elimina documento",
              text: "Elimina documento"
            })
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", null, [
          _createElementVNode("button", {
            type: "button",
            class: _normalizeClass(["btn btn-border", { 'btn-primary': _ctx.tab == 1 }]),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.tab = 1))
          }, [
            _createVNode(_component_localized_text, {
              localizedKey: "Dettagli",
              text: "Dettagli"
            })
          ], 2)
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("button", {
            type: "button",
            class: _normalizeClass(["btn btn-border", { 'btn-primary': _ctx.tab == 2 }]),
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.tab = 2))
          }, [
            _createVNode(_component_localized_text, {
              localizedKey: "Visibilità",
              text: "Visibilità"
            }),
            (_ctx.vm.visibleBy.length > 0)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode("(" + _toDisplayString(_ctx.vm.visibleBy.length) + " ", 1),
                  _createVNode(_component_localized_text, {
                    localizedKey: "selezionati",
                    text: "selezionati"
                  }),
                  _hoisted_5
                ], 64))
              : _createCommentVNode("", true)
          ], 2)
        ])
      ]),
      _hoisted_6,
      _withDirectives(_createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("label", null, [
            _createVNode(_component_localized_text, {
              localizedKey: "Nome",
              text: "Nome"
            })
          ]),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.vm.name) = $event))
          }, null, 512), [
            [_vModelText, _ctx.vm.name]
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("label", _hoisted_10, [
            _createVNode(_component_localized_text, {
              localizedKey: "Cartella",
              text: "Cartella"
            })
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.folders, (item, i) => {
            return (_openBlock(), _createElementBlock("span", {
              class: "label pointer mr-1",
              key: i,
              onClick: ($event: any) => (_ctx.vm.folder = item.name)
            }, _toDisplayString(item.name), 9, _hoisted_11))
          }), 128)),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control",
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.vm.folder) = $event))
          }, null, 512), [
            [_vModelText, _ctx.vm.folder]
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("label", null, [
            _createVNode(_component_localized_text, {
              localizedKey: "Descrizione",
              text: "Descrizione"
            })
          ]),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control",
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.vm.description) = $event))
          }, null, 512), [
            [_vModelText, _ctx.vm.description]
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("label", null, [
            _createVNode(_component_localized_text, {
              localizedKey: "Documento",
              text: "Documento"
            })
          ]),
          (!_ctx.preview)
            ? (_openBlock(), _createBlock(_component_file_dropper, {
                key: 0,
                modelValue: _ctx.fileToUpload,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.fileToUpload) = $event))
              }, null, 8, ["modelValue"]))
            : (_openBlock(), _createElementBlock("a", {
                key: 1,
                target: "_blank",
                src: _ctx.preview,
                class: "preview pointer"
              }, [
                _createElementVNode("object", {
                  value: _ctx.preview,
                  type: "image/png"
                }, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Impossibile caricare l'anteprima",
                    text: "Impossibile caricare l'anteprima"
                  })
                ], 8, _hoisted_15),
                _createElementVNode("button", {
                  type: "button",
                  onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => {_ctx.preview = null; _ctx.fileToUpload = null}, ["stop","prevent"]))
                }, "Modifica")
              ], 8, _hoisted_14))
        ])
      ], 512), [
        [_vShow, _ctx.tab == 1]
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("h5", null, [
            _createVNode(_component_localized_text, {
              localizedKey: "Se nessuno selezionato, visibile a tutti",
              text: "Se nessuno selezionato, visibile a tutti"
            })
          ]),
          (_ctx.vm.visibleBy.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-sm btn-primary",
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.vm.visibleBy.splice(0)))
                }, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Svuota",
                    text: "Svuota"
                  })
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _hoisted_19,
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              _withDirectives(_createElementVNode("select", {
                class: "form-control",
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.roleFilter) = $event))
              }, [
                _createElementVNode("option", _hoisted_23, _toDisplayString(_ctx.$localizationService.GetLocalizedValue("Filtra per ruolo", "Filtra per ruolo")), 1),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.roles, (item) => {
                  return (_openBlock(), _createElementBlock("option", { key: item }, _toDisplayString(item), 1))
                }), 128))
              ], 512), [
                [_vModelSelect, _ctx.roleFilter]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary",
              onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.selectAll && _ctx.selectAll(...args)))
            }, [
              _createVNode(_component_localized_text, {
                localizedKey: "Aggiungi tutta la tabella",
                text: "Aggiungi tutta la tabella"
              })
            ])
          ])
        ]),
        _hoisted_25,
        _createVNode(_component_op_table, {
          class: "table table-striped",
          items: _ctx.users
        }, {
          default: _withCtx((opData) => [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("td", _hoisted_26, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Nome",
                    text: "Nome"
                  })
                ]),
                _hoisted_27
              ])
            ]),
            _createElementVNode("tbody", null, [
              (opData.items.length == 0)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_28, [
                    _createElementVNode("td", _hoisted_29, [
                      _createVNode(_component_localized_text, {
                        localizedKey: "Nessun elemento trovato",
                        text: "Nessun elemento trovato"
                      })
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(opData.items, (item, i) => {
                return (_openBlock(), _createElementBlock("tr", { key: i }, [
                  _createElementVNode("td", null, _toDisplayString(item.name), 1),
                  _createElementVNode("td", null, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      class: "checkBig",
                      value: item.identifier,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.vm.visibleBy) = $event))
                    }, null, 8, _hoisted_30), [
                      [_vModelCheckbox, _ctx.vm.visibleBy]
                    ])
                  ])
                ]))
              }), 128))
            ])
          ]),
          _: 1
        }, 8, ["items"])
      ], 512), [
        [_vShow, _ctx.tab == 2]
      ])
    ]),
    _createElementVNode("div", _hoisted_31, [
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-success mr-2",
        disabled: !_ctx.canSave,
        onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args)))
      }, [
        _createVNode(_component_localized_text, {
          localizedKey: "Salva",
          text: "Salva"
        })
      ], 8, _hoisted_32),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-danger",
        onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.$emit('close')))
      }, [
        _createVNode(_component_localized_text, {
          localizedKey: "Annulla",
          text: "Annulla"
        })
      ])
    ])
  ]))
}